// extracted by mini-css-extract-plugin
export default {"errorLogsContainer":"errorLogsContainer---tqRkA"};